import React from "react";
import Button from "@material-ui/core/Button";
import useStyles from "./AnalyzeButton.styles";

export default function AnalyzeButton({ onClick, disabled }) {
  const classes = useStyles();

  return (
    <Button
      className={classes.analyze}
      variant="contained"
      size="small"
      disabled={disabled}
      onClick={(e) => {
        e.preventDefault();
        onClick && onClick(e);
      }}
    >
      Analisar
    </Button>
  );
}
